import { render, staticRenderFns } from "./ScheduleHoliday.vue?vue&type=template&id=770fd7bc&scoped=true&"
import script from "./ScheduleHoliday.vue?vue&type=script&lang=js&"
export * from "./ScheduleHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770fd7bc",
  null
  
)

export default component.exports